import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Chip, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SearchFilter from '@ui/components/Button/SearchFilter';
const ReassignPickupLocationMini = ({ options, onSelect, eventIcon, onSearchChange }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const handleSearchChange = (value) => {
        setSearch(value);
        onSearchChange?.(value);
    };
    const filtered = options.filter((opt) => `${opt.address} ${opt.eventName}`.toLowerCase().includes(search.toLowerCase()));
    return (_jsxs(Box, { sx: {
            borderRadius: 2,
            bgcolor: theme.palette.background.paper,
            maxHeight: 320,
            overflow: 'hidden',
            width: 360
        }, children: [_jsx(Box, { sx: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    bgcolor: theme.palette.background.paper,
                    px: 1.5,
                    pt: 1.5,
                    pb: 1
                }, children: _jsx(SearchFilter, { fullWidth: true, searchValue: search, onSearchChange: handleSearchChange, placeholder: t('placeholders.search'), breakpoint: 'lg', onClear: () => handleSearchChange(''), widthBox: '100%' }) }), _jsxs(Box, { sx: {
                    maxHeight: 260,
                    overflowY: 'auto',
                    px: 1.5,
                    pb: 1.5
                }, children: [filtered.map((opt) => (_jsxs(Box, { sx: {
                            py: 1,
                            borderBottom: '1px solid',
                            borderColor: theme.palette.divider,
                            cursor: 'pointer',
                            '&:last-of-type': { borderBottom: 'none' }
                        }, onClick: () => onSelect(opt), children: [_jsx(Typography, { variant: 'body2', children: opt.address }), _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 0.5, children: [eventIcon && _jsx(Box, { sx: { display: 'flex', alignItems: 'center' }, children: eventIcon }), _jsx(Typography, { variant: 'caption', color: 'text.secondary', children: opt.eventName })] }), opt.capacity && (_jsx(Chip, { size: 'small', variant: 'soft', color: 'info', label: `${opt.capacity.remaining}/${opt.capacity.total} ${t('events.eventDetails.transportTab.seats')}`, sx: {
                                            ml: 'auto'
                                        } }))] })] }, opt.id))), filtered.length === 0 && (_jsx(Typography, { variant: 'caption', color: 'text.secondary', children: t('dataGrid.noResults') }))] })] }));
};
export default ReassignPickupLocationMini;
